export const defaultColors = ["#48BB78", "#0BC5EA"];
export const pregnantRisks = ["#48BB78", "#ED8936", "#C53030"];
export const pregnantRisksAlt = ["#48BB78", "#805AD5", "#C53030"];